module.exports = __webpack_public_path__ + "static/media/ProximaNovaReg.f4479007.otf";